import { Routes } from '@angular/router';
import { Complete } from './components/complete/complete';
import { FileForm } from './components/file/file';
import { Home } from './components/home/home';
import { CourtDocuments } from './components/court-documents/court-documents';
import { Notice } from './components/notice/notice';
import { Contact } from './components/contact/contact';
import { FAQS } from './components/faqs/faqs';
import { ImportantDates } from './components/important-dates/important-dates';
import { ClaimForm } from './components/claim-form/claim-form';
import { ProcessLink } from './components/processlink/processlink';


export const routes: Routes = [ 
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'file', component: FileForm },
  { path: 'home', component: Home },
  { path: 'court-documents', component: CourtDocuments },
  { path: 'notice', component: Notice },
  { path: 'contact', component: Contact },
  { path: 'faqs', component: FAQS },
  { path: 'important-dates', component: ImportantDates },
  { path: 'claim-form', component: ClaimForm },
  { path: 'complete', component: Complete },
  { path: 'processlink', component: ProcessLink },

  { path: '**', redirectTo: 'home' },

];
